<template>
  <div :class="{hasError:isError}" style="width: 100%;"> 
    
          <DataTable :value="value" dataKey="VendorCode" :disabled="disabled" >
           
           <Column field="IsSelect" header="IsSelect">
                   <template #body="slotProps">
                       <Checkbox v-model="slotProps.data.IsSelect" :binary="true" :disabled="disabled" />          
                   </template>
           </Column>

           <Column field="VendorCode" header="Vendor Code" bodyStyle="padding: 0rem 1rem;" headerStyle="padding: 0.5rem 1rem;"></Column>
           <Column field="VendorName" header="Vendor Name" bodyStyle="padding: 0rem 1rem;" headerStyle="padding: 0.5rem 1rem;"></Column>
           
            
        </DataTable>
       

    </div>
</template>  
<script>

import Service from "../../service/service";
import SapService from "../../service/SapService";

export default {
    props: ["modelValue", "supervisorVendorcode", 'disabled'],
    emits: ["update:modelValue"],
    
    data() {
        return {
            value: [],
            displayTable: "none",
        }
    },
    Service: null,
    SapService: null,
    created() {
        this.Service = new Service();
        this.SapService = new SapService();
         this.value=this.modelValue;
       
    },
    methods: {
        
        

    },
    watch: {
        value: function () {
              // watch it
              //console.log("value Prop changed: ", this.value);
              this.$emit("update:modelValue", this.value );
            },
       
    },
    computed: {
      isError() {
            return   !this.disabled && this.value.filter(x=>x.IsSelect==true).length==0     ;
    },
    }
}
</script>
  

<style scoped>
.hasError label {
  color:red;
  border-color: red;
  border-width: thin;
}
.hasError  {
  color:red;
  border-color: red;
  border-width: thin;
  border: 1px solid;
  border-radius: 5px;
}
</style>